import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UIRouterModule } from "@uirouter/angular";
import { CommonComponentsModule } from "../../entry/common-components.module";
import { ConfigManagerService } from "../../../common/services/configmanager.service";
import { DMLoggerService } from "../../../common/services/dmlogger.service";
import { InvoiceService } from "../../../common/services/invoices.service";
import { InvoiceTableDataComponent } from "./invoice-table-data.component";
import { SharedFunctionsService } from "../../../common/services/sharedfunctions.service";


@NgModule({
    declarations: [
        InvoiceTableDataComponent
    ],
    imports: [
        CommonComponentsModule,
        CommonModule,
        UIRouterModule
    ],
    providers: [
        ConfigManagerService,
        DMLoggerService,
        InvoiceService,
        SharedFunctionsService
    ],
    exports: [
        InvoiceTableDataComponent
    ],
    entryComponents: [
        InvoiceTableDataComponent
    ]
})
export class InvoiceTableDataModule { }
